import type { ApiClient } from '@travel/api-client';
import { MONTEROSA_API_TIMEOUT } from '@travel/traveler-core/constants';

import type {
  AreaDetailsItems,
  AreaRelatedItems,
  AreaRelatedRequestBody,
  RecommendedAreaResponse,
  SearchRequestBody,
} from 'AreaDetails-Types';

export const fetchAreaDetailsItems = (
  http: ApiClient,
  req: SearchRequestBody,
  ignoreCommonErrorHandler?: boolean,
): Promise<AreaDetailsItems> =>
  http.post('/monterosa-api/v2/area-details', {
    method: 'POST',
    req: { ...req },
    values: { ...req },
    ignoreCommonErrorHandler: ignoreCommonErrorHandler,
    timeout: MONTEROSA_API_TIMEOUT,
  });

export const fetchRecommendedAreaAPI = (
  http: ApiClient,
  ignoreCommonErrorHandler?: boolean,
): Promise<RecommendedAreaResponse> =>
  http.get('/monterosa-api/recommended-area', {
    ignoreCommonErrorHandler: ignoreCommonErrorHandler,
  });

export const fetchAreaRelatedItems = (
  http: ApiClient,
  req: AreaRelatedRequestBody,
  ignoreCommonErrorHandler?: boolean,
): Promise<AreaRelatedItems> =>
  http.post('/monterosa-api/area-related', {
    method: 'POST',
    req: { ...req },
    values: { ...req },
    ignoreCommonErrorHandler: ignoreCommonErrorHandler,
  });
